/**
 * @param onSubmit {(form: HTMLFormElement) => void}
 * @return {void}
 */
module.exports = function listenForWhitepaperForm2024Submit(onSubmit) {
    window.document.querySelectorAll('[data-component="whitepaper-form-container"] form').forEach(whitepaperForm => {
        if (whitepaperForm instanceof HTMLFormElement) {
            whitepaperForm.addEventListener('submit', e => {
                e.preventDefault();

                const form = e.currentTarget;

                if (form instanceof HTMLFormElement) {
                    onSubmit(form);
                }
            });
        }
    });
}
